import { assessmentItemType, observationRole } from '../learnableMoments';

const env = process.env.REACT_APP_ENV || process.env.NODE_ENV

/**
 * Important: if you change something here you most likely have to change something in survey.service.js AND in the related limesurvey survey.
 */
const baseExternalIds = [];
if (env !== 'production') {
  baseExternalIds.push('23190');
  baseExternalIds.push('1001');
}

/**
 * TODO:
 * get from akzento-plus
 * - all courses of current semester
 *  - with meta.tools.360grad !== undefined
 *  - group by meta.tools.360grad.course
 *    - contains: name, title, assessmentItems
 */

export const courses = [
  {
    // Medical Skills Lab - Termin 1..6, 8..12
    // LimeSurvey: KA
    id: '1',
    externalIds: env === 'production' ? ['31887', '31873', '31829', '31832', '31830', '31861', '31890', '31860', '31886', '31872', '31876'] : baseExternalIds,
    name: 'anamnesis-training',
    title: 'Anamnese',
    assessmentItems: ['nepa-a']
  },
  {
    // Medical Skills Lab - Visitentraining I, Praktikum Medical Skills Lab - Übergabetraining Tag 1, Praktikum Medical Skills Lab - Übergabetraining Tag 2
    // LimeSurvey: KVT
    id: '2',
    externalIds: ['31907', '31836'],
    name: 'ward-round-training',
    title: 'Visitentraining',
    assessmentItems: ['nepa-au']
  },
  // {
  //   id: '3',
  //   externalIds: [], // TODO
  //   name: 'medical-thinking-and-acting',
  //   title: 'Ärztliches Denken und Handeln',
  //   assessmentItem s: ['nepa-au']
  // },
  {
    // Praktikum der Präventionsmedizin - Raucherentwöhnung
    // LimeSurvey: KPM
    id: '4',
    externalIds: ['31967'],
    name: 'preventive-medicine',
    title: 'Präventionsmedizin',
    assessmentItems: ['nepa-pm'],
  },
  {
    // Notfallmedizin II - Skillstraining
    id: '5',
    externalIds: ['32254'],
    name: 'emergency-medicine-2',
    title: 'Notfallmedizin 2',
    assessmentItems: ['nepa-em2']
  },
  // {
  //   id: '6',
  //   externalIds: [], // TODO
  //   name: 'surgeon-basic-skills-1',
  //   title: 'Chirurgische Basisfertigkeiten',
  //   assessmentItems: ['nepa-cb1']
  // },
  {
    // Praktikum der Psychiatrie
    id: '7',
    externalIds: ['32113'],
    name: 'psychiatry-internship',
    title: 'Praktikum der Psychiatrie',
    assessmentItems: ['nepa-a']
  },
  {
    // Medical Skills Lab - Termin 2
    // LimeSurvey: MLB
    id: '8',
    externalIds: env === 'production' ? ['31873'] : baseExternalIds,
    name: 'mastery-learning-bp',
    title: 'Mastery Learning - Blutdruck',
    assessmentItems: ['nepa-ml-bd', 'checklist-bd']
  },
]

export const conceptualFrameworkItems = [
  {
    id: 'nepa-a',
    title: 'Eine fokussierte Anamnese bei einem erwachsenen Patienten durchführen.',
    type: assessmentItemType.NEPA
  },
  {
    id: 'nepa-ml-bd',
    title: 'Nichtinvasve Blutdruckmessung bei einem erwachsenen Patienten.',
    type: assessmentItemType.NEPA
  },
  {
    id: 'checklist-bd',
    title: 'Checkliste nichtinvasive Blutdruckmessung',
    type: assessmentItemType.CHECKLIST,
    groups: [
      {
        id: 'checklist-bd-g1',
        title: 'Zusammensuchen aller benötigten Materialien und Lagerung',
        items: [
          { id: 'checklist-bd-g1-1', title: 'Manschette', points: 1 },
          { id: 'checklist-bd-g1-2', title: 'Korrekte Größe der Manschette beachtet', points: 1 },
          { id: 'checklist-bd-g1-3', title: 'Stethoskop', points: 1 },
          { id: 'checklist-bd-g1-4', title: 'Patient entspannt sitzend, Arm abgelegt', points: 1 },
        ]
      },
      {
        id: 'checklist-bd-g2',
        title: 'Messung',
        items: [
          { id: 'checklist-bd-g2-1', title: 'Entkleidenlassen des betroffenen Arms', points: 1 },
          { id: 'checklist-bd-g2-2', title: 'Korrekte Position der Manschette', points: 2 },
          { id: 'checklist-bd-g2-3', title: 'Korrektes Aufsetzen des Stethoskops', points: 1 },
          { id: 'checklist-bd-g2-4', title: 'Aufblasen auf Druck oberhalb des Systolenwertes', points: 2 },
          { id: 'checklist-bd-g2-5', title: 'Langsames Ablassen (2—3 mmHg/Sek)', points: 1 },
        ]
      },
      {
        id: 'checklist-bd-g3',
        title: 'Kommunikation',
        noPoints: true,
        items: [
          { id: 'checklist-bd-g3-1', title: 'Erklärung des Vorgehens' },
        ]
      },
      {
        id: 'checklist-bd-g4',
        title: 'Hygiene',
        items: [
          { id: 'checklist-bd-g4-1', title: 'Händedesinfektion vor Patientenkontakt', points: 1 },
          { id: 'checklist-bd-g4-2', title: 'Händedesinfektion nach Patientenkontakt', points: 1 },
        ]
      },
      {
        id: 'checklist-bd-g5',
        title: 'Nachbereitung',
        items: [
          { id: 'checklist-bd-g5-1', title: 'Wischdesinfektion der Manschette', points: 1 },
          { id: 'checklist-bd-g5-2', title: 'Wischdesinfektion des Stethoskops', points: 1 },
          { id: 'checklist-bd-g5-3', title: 'ggf. Wischdesinfektion der Auflagefläche', points: 1 },
        ]
      },
    ]

  },
  {
    id: 'nepa-au',
    title: 'Eine fokussierte Anamnese und Untersuchung bei einem erwachsenen Patienten durchführen.',
    type: assessmentItemType.NEPA
  },
  {
    id: 'nepa-pm',
    title: 'Eine Kurzintervention zur Tabakentwöhnung anhand der <em>5-A-Strategie</em> durchführen.',
    type: assessmentItemType.NEPA
  },
  {
    id: 'nepa-em2',
    title: 'Eine Notfallbehandlung und Koordination der Versorgung kritisch kranker Patienten durchführen.',
    type: assessmentItemType.NEPA
  },
  {
    id: 'nepa-cb1',
    title: 'Eine fokussierte Anamnese und Untersuchung bei einem Patienten mit adominellen Beschwerden durchführen.',
    type: assessmentItemType.NEPA
  }
]

export const rooms = [
  {id: '19', title: 'Kleingruppenraum 11', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '1', title: 'Kleingruppenraum 12', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '2', title: 'Kleingruppenraum 13', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '3', title: 'Kleingruppenraum 14', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '4', title: 'Kleingruppenraum 15', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '5', title: 'Kleingruppenraum 16', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '6', title: 'Kleingruppenraum 17', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '7', title: 'Kleingruppenraum 18', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '8', title: 'Kleingruppenraum 19', roles: [observationRole.TUTOR], defaultSpRoomId: null},
  {id: '9', title: 'Intensivzimmer 1', roles: [observationRole.SP]},
  {id: '10', title: 'Intensivzimmer 2', roles: [observationRole.SP]},
  {id: '11', title: 'Krankenzimmer 3', roles: [observationRole.SP]},
  {id: '12', title: 'Krankenzimmer 4', roles: [observationRole.SP]},
  {id: '13', title: 'Krankenzimmer 5', roles: [observationRole.SP]},
  {id: '14', title: 'Krankenzimmer 6', roles: [observationRole.SP]},
  {id: '15', title: 'Praxis A', roles: [observationRole.SP]},
  {id: '16', title: 'Praxis B', roles: [observationRole.SP]},
  {id: '17', title: 'Praxis C', roles: [observationRole.SP]},
  {id: '18', title: 'Praxis D', roles: [observationRole.SP]},
]

const getByTitle = (list, title = '') => list.find(i => i.title.toLowerCase() === title.toLowerCase())
export const getCourseByTitle = title => getByTitle(courses, title)
export const getRoomByTitle = title => getByTitle(rooms, title)

export const getGroupByTitle = title => {
  const res = /^([1-6]?)-h([0-9]+)$/g.exec(title);
  if (!res) {
    return;
  }
  // ID from AKzento for a specific clinical group (in the clinical phase).
  return `3.20${res[1]}.H${res[2]}`
}